import { Box } from "@mui/material";
import styled from "styled-components";

export const ReviewAppointmentStyled = styled(Box)`
  .row {
    padding: 16px;
    margin-bottom: 12px;
    border: 1px solid #ddd;
    border-radius: 8px;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    > div {
      margin-right: 16px;
    }
  }

  .row2 {
    display: flex;
    gap: 80px;

    > div {
      display: flex;
      flex-direction: column;
    }
  }

  .label {
    font-weight: bold;
    font-size: 14px;
    color: #555;
    margin-bottom: 4px;
  }

  .value {
    font-size: 14px;
    color: #333;
  }
`;
